/* eslint-disable max-len */
const texts = {
  title: 'AI Workout Generator Instructions',
  instructions: `
  <p><strong>Include these essentials:</strong></p>
  <ul>
    <li><strong>Client Level:</strong> beginner / intermediate / advanced</li>
    <li><strong>Primary Goal:</strong> weight loss, muscle gain, strength, endurance, flexibility, etc.</li>
    <li><strong>Session Duration:</strong> e.g., <em>20 minutes</em> (exact) — write as “20 min”, “25 minutes”</li>
    <li><strong>Format:</strong> Individual Exercises / Circuits / Hybrid</li>
    <li><strong>Equipment:</strong> dumbbells, bands, bodyweight, gym equipment, etc. or none</li>
    <li><strong>Location:</strong> home / gym / outdoors</li>
    <li><strong>Limitations:</strong> injuries, pain, movements to avoid</li>
    <li><strong>Intensity:</strong> low / moderate / high</li>
    <li><strong>Style:</strong> HIIT, circuit training, strength, endurance, yoga, etc.</li>
    <li><strong>Specific Needs:</strong> sport-specific, functional training, mobility block, finisher, etc.</li>
    <li><strong>Focus Areas:</strong> upper body, core, lower body, full body</li>
  </ul>

  <p><strong>Quick examples (notice the explicit duration & format):</strong></p>
  <ul>
    <li>“Intermediate strength workout for muscle gain with dumbbells at home, 30 minutes, Individual format, focus on upper body and core.”</li>
    <li>“Beginner bodyweight circuit for weight loss, full body, 20 minutes, no jumping or wrist-loaded positions.”</li>
    <li>“Advanced HIIT session for endurance, gym equipment available, 25 minutes, Hybrid (main lift + metcon), include plyometrics, avoid deep knee flexion.”</li>
  </ul>

  <p><strong>Tips for best results:</strong></p>
  <ul>
    <li><strong>Be explicit</strong> and explain without being vague.</li>
    <li>If you don’t care about a field, write <em>“no preference”</em> so the AI can choose intelligently.</li>
    <li>AI doesn't work well on <strong>negative sentiments</strong>. Try to be positive (e.g., "have pushups" instead of "avoid burpees").</li>
    <li>More detail = a more personalized, safer plan.</li>
    <li><strong>If improving a plan:</strong> say exactly what to change (e.g., “change the whole workout duration to 30 min keeping the main lifts, add anti-rotation core”)</li>
  </ul>
  `,
};

export default texts;
